export default "__VITE_ASSET__By7pyjfJ__"